import { formatTextNumber } from "@/utils/number";
import { z } from "zod";

export const supplySchema = z
  .object({
    id: z.number().optional(),
    resourceName: z.string().min(1, "Debes ingresar un nombre válido"),
    initialQuantity: z.preprocess(
      (v) => +formatTextNumber(String(v)),
      z
        .number({ invalid_type_error: "Debes ingresar el saldo inicial" })
        .finite()
        .gte(0, "No puede ser un número negativo")
    ),
    finalQuantity: z.preprocess(
      (v) => +formatTextNumber(String(v)),
      z
        .number({ invalid_type_error: "Debes ingresar el saldo final" })
        .finite()
        .gte(0, "No puede ser un número negativo")
    ),
    incomeQuantity: z.preprocess(
      (v) => +formatTextNumber(String(v)),
      z
        .number({ invalid_type_error: "Debes ingresar la cantidad ingresada" })
        .finite()
        .gte(0, "No puede ser un número negativo")
    ),
    comment: z.string().optional(),
    photoUrl: z.string().optional(),
  })
  .refine(
    (data) => {
      return data.finalQuantity <= data.initialQuantity + data.incomeQuantity
        ? true
        : data.comment;
    },
    {
      message:
        "El consumo no puede ser negativo. Si hubo errores, ingrese un comentario",
      path: ["comment"],
    }
  )
  .refine(
    (data) => {
      if (data.resourceName.includes("Diesel")) return Boolean(data.photoUrl);
      return true;
    },
    {
      message: "Debes subir un respaldo que indique la cantidad de diesel",
      path: ["photoUrl"],
    }
  );
export type SupplySchema = z.infer<typeof supplySchema>;
